var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33420_2061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0132 4.13347L1.93659 19.7827C1.55662 20.4377 2.02929 21.2587 2.7872 21.2587H20.9403C21.6982 21.2587 22.1709 20.4377 21.7909 19.7827L12.7134 4.13347C12.3344 3.48049 11.3911 3.48049 11.0121 4.13347H11.0132Z",
    fill: "url(#paint0_linear_33420_2061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0134 4.13369C8.46262 8.54769 4.57528 15.2986 2.05605 19.7065C1.98678 19.8267 1.90223 19.9774 1.88593 20.119C1.80444 20.554 2.08967 21.0257 2.51752 21.1438C2.74877 21.2121 3.18375 21.1734 3.43638 21.1805C4.62927 21.1693 11.5411 21.1632 12.8919 21.1581L20.4557 21.1724H20.9284C21.5314 21.1958 22.0153 20.5428 21.7932 19.9744C19.4401 15.7712 15.9775 9.82106 13.5744 5.63117L13.1018 4.81214C12.9693 4.59923 12.7707 4.205 12.6169 4.00228C12.2104 3.47969 11.3333 3.55405 11.0134 4.13369ZM11.0134 4.13369C11.3313 3.55405 12.2124 3.47052 12.623 3.99718C12.7778 4.21111 12.9724 4.57478 13.1119 4.80705L13.5877 5.62404C15.9694 9.7253 19.438 15.6144 21.8299 19.6983C22.1732 20.2066 21.9787 20.9595 21.4224 21.2284C21.1657 21.3792 20.743 21.3435 20.4557 21.3466C15.7809 21.3578 8.09691 21.3649 3.43638 21.3384C3.16847 21.3241 2.74469 21.37 2.47372 21.2865C2.1457 21.1897 1.88491 20.9167 1.78508 20.5958C1.6771 20.2698 1.75656 19.9224 1.944 19.6423C4.50703 15.2711 8.46058 8.53343 11.0134 4.13369Z",
    fill: "#FFC11E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4812 15.5969H11.0551L10.7688 8.06464H12.7675L12.4812 15.5969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7672 19.4037C12.3911 19.4037 12.8969 18.8979 12.8969 18.274C12.8969 17.65 12.3911 17.1442 11.7672 17.1442C11.1432 17.1442 10.6375 17.65 10.6375 18.274C10.6375 18.8979 11.1432 19.4037 11.7672 19.4037Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33420_2061",
    x1: 11.5,
    y1: 13,
    x2: 13,
    y2: -9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFD220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFBD00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33420_2061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2639,
    height: 17.7131,
    fill: "white",
    transform: "translate(1.73608 3.64346)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.e5712b3cf35b48cab6a253d76dd2d214.svg";
export { ForwardRef as ReactComponent };